import ChatListSidebarButton from "./ChatListSidebarButton"
import SlickAISidebarButton from "./SlickAISidebarButton"
import { SidebarProvider } from "./SidebarContext"
import CMRSidebarButton from "./CMRSidebarButton"
import CarIssuesSidebarButton from "./CarIssuesSidebarButton"
import FleetOverviewSidebarButton from "./FleetOverviewSidebarButton"
import PlanOrderSidebarButton from "./PlanOrderSidebarButton"
import AvatarImage, { participantPhotoToSrc } from "@/components/AvatarImage"
import { useContext, useState } from "react"
import { XmppContext } from "@/stream/xmppClient"
import { useAppSelector } from "@/reducers/hooks"
import { findProfile } from "@/reducers/profilesSliceSelectors"
import ProfileInfo from "@/components/ProfileInfo"
import ReportSidebarButton from "@/components/sidebar/ReportSidebarButton"
import FuelReportSidebarButton from "@/components/sidebar/FuelReportSidebarButton"
import DeliveryOrdersSidebarButton from "@/components/sidebar/DeliveryOrdersSidebarButton"
import DriverManagementSidebarButton from "@/components/sidebar/DriverManagementSidebarButton"
import CrewBoardSidebarButton from "@/components/sidebar/CrewBoardSidebarButton"
import DailyRoutesSidebarButton from "@/components/sidebar/DailyRoutesSidebarButton"
import StatsSidebarButton from "@/components/sidebar/StatsSidebarButton"
import MyCarsSidebarButton from "@/components/sidebar/MyCarsSidebarButton"
import TimelineSidebarButton from "@/components/sidebar/TimelineSidebarButton"
import UserManagementSidebarButton from "@/components/sidebar/UserManagementSidebarButton"
import GpsManagementSidebarButton from "@/components/sidebar/GpsManagementSidebarButton"
import { useFeatureFlagEnabled } from "posthog-js/react"

export const SIDEBAR_WIDTH = 48

type SidebarPropsType = {
  onActiveChatChange: (chatJid: string) => void
  onNavigate?: () => void
}

const Sidebar = ({ onActiveChatChange, onNavigate }: SidebarPropsType) => {
  const { myJid } = useContext(XmppContext)
  const profile = useAppSelector(findProfile(myJid.bare().toString()))
  const [isProfileOpen, setProfileOpen] = useState(false)
  const isSimpleMenu = Boolean(useFeatureFlagEnabled("simple-menu"))
  return (
    <SidebarProvider
      onActiveChatChange={onActiveChatChange}
      onNavigate={onNavigate}
    >
      <div
        className={`z-[999] h-screen w-[${SIDEBAR_WIDTH}px] border-r border-gray-200 bg-muted dark:border-border`}
      >
        <div className="m-2 mt-4 flex flex-col gap-3">
          {isSimpleMenu ? (
            <>
              <ChatListSidebarButton />
              <SlickAISidebarButton />
              <PlanOrderSidebarButton />
            </>
          ) : (
            <>
              <ChatListSidebarButton />
              <SlickAISidebarButton />
              <TimelineSidebarButton />
              <CMRSidebarButton />
              <CarIssuesSidebarButton />
              <FleetOverviewSidebarButton />
              <PlanOrderSidebarButton />
              <ReportSidebarButton />
              <FuelReportSidebarButton />
              <DeliveryOrdersSidebarButton />
              <StatsSidebarButton />
              <DriverManagementSidebarButton />
              <CrewBoardSidebarButton />
              <DailyRoutesSidebarButton />
              <MyCarsSidebarButton />
              <UserManagementSidebarButton />
              <GpsManagementSidebarButton />
            </>
          )}
        </div>
        <div
          className="absolute bottom-4 left-2 cursor-pointer"
          onClick={() => setProfileOpen(true)}
        >
          <AvatarImage
            name={profile?.name || ""}
            src={participantPhotoToSrc(profile?.photo)}
          />
        </div>
      </div>
      <ProfileInfo
        isOpen={isProfileOpen}
        onClose={() => setProfileOpen(false)}
      />
    </SidebarProvider>
  )
}

export default Sidebar
